export default "__VITE_ASSET__DbTXV6Sj__"